import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import FormInput from '../../../commonComponents/forms/FormInput';
import { compose } from '../../../services/utilityFunctions';
import AccessSessionProp from '../../../commonComponents/propTypes/accessSessionProp';

const WEBINAR_TYPES = {
  GENERIC: 'generic',
  WEBEX: 'webex',
};

const items = t => [
  {
    id: WEBINAR_TYPES.GENERIC,
    text: t('generic'),
  },
  {
    id: WEBINAR_TYPES.WEBEX,
    text: t('webex'),
  },
];

const TabSessionDetailsWebinar = props => {
  const { t, isFinished, accessSession, handleChange, createUser, createTrainer, isWebexActive, isDuplicate } = props;
  const hasMeetingId = accessSession?.webinar?.id || null;
  const currentMoment = new Date().valueOf();
  const isPastStartDate = accessSession._id && accessSession?.startDate ? accessSession?.startDate < currentMoment : false;
  const handleWebinarChange = field => value => {
    if (field === 'provider') {
      const webinar = {
        ...accessSession.webinar,
        [field]: value,
      };
      delete webinar.url;
      handleChange('webinar')(webinar);
    } else {
      handleChange('webinar')({
        ...accessSession.webinar,
        [field]: value,
      });
    }
  };
  return (
    <div className="tab2-webinar row">
      <div className="col-lg-6 block-webinar">
        {isWebexActive && (
          <>
            <FormInput
              disabled={!isDuplicate && (isFinished || isPastStartDate)}
              id="provider"
              name="provider"
              value={accessSession.webinar?.provider || WEBINAR_TYPES.GENERIC}
              onChange={handleWebinarChange('provider')}
              label={t('session.webinar.provider')}
              labelClassName="col-form-label col-2 text-right"
              containerClassName="col-9 row no-gutters"
              type="select"
              groupProps={{ className: 'row' }}
              inputProps={{
                width: '100%',
                multiple: false,
                items: () => items(t),
              }}
            />
            {accessSession?.webinar?.provider === WEBINAR_TYPES.WEBEX && (
              <div className="webex-hintContainer row">
                <div className="col-2" />
                <div className="col-9 row no-gutters">
                  <span className="webex-hint">{t('session.webinar.provider.webex.hint')}</span>
                  {hasMeetingId && !isDuplicate && (
                    <div className="webex-meetingId">
                      {t('session.webinar.provider.webex.meetingId')}
                      <span className="meetingId">{accessSession?.webinar?.id}</span>
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        )}
        {accessSession?.webinar?.provider !== WEBINAR_TYPES.WEBEX && (
          <FormInput
            type="text"
            id="linkWebinar"
            name="linkWebinar"
            label={t('access_session.detail.link')}
            labelClassName="col-form-label col-2 text-right"
            containerClassName="col-9 row no-gutters"
            groupProps={{ className: 'row' }}
            placeholder={t('access_session.detail.zoomLink.placeholder')}
            onChange={handleWebinarChange('url')}
            value={accessSession.webinar?.url}
            disabled={isFinished}
          />
        )}
        <div className="hostSelectContainer">{createUser('host', 'col-2 text-right', 'col-9 row no-gutters no-wrap', false)}</div>
      </div>
      <div className="col-lg-6 mobile-session-details">
        <div className="col-lg-12 block-webinar">
          {createTrainer('trainer', 'col-2 text-right', 'col-9 row no-gutters', false)}
        </div>
      </div>
    </div>
  );
};

TabSessionDetailsWebinar.propTypes = {
  t: PropTypes.func.isRequired,
  isFinished: PropTypes.bool,
  accessSession: PropTypes.shape(AccessSessionProp.propType).isRequired,
  handleChange: PropTypes.func.isRequired,
  createUser: PropTypes.func.isRequired,
  createTrainer: PropTypes.func.isRequired,
  isWebexActive: PropTypes.bool,
  isDuplicate: PropTypes.bool,
};

TabSessionDetailsWebinar.defaultProps = {
  isFinished: false,
  isWebexActive: false,
  isDuplicate: false,
};

export default compose(
  translate,
)(TabSessionDetailsWebinar);
